import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { Loader } from "lucide-react";

const ProtectedRoute = ({
  children,
  roles,
}: {
  children: React.ReactNode;
  roles?: string[];
}) => {
  const { authUser, isCheckingAuth } = useAuthStore();

  if (isCheckingAuth)
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-slate-50">
        <div className="relative">
          <div className="absolute inset-0 blur-3xl bg-blue-400/20 animate-pulse rounded-full"></div>
          <Loader className="size-14 animate-spin text-[#2462b2] relative z-10" />
        </div>
      </div>
    );

  if (!authUser) return <Navigate to="/login" replace />;

  // Role gate: send anyone not in `roles` to their own home.
  if (roles && !roles.includes(authUser.role)) {
    return <Navigate to={authUser.role === "Client" ? "/portal" : "/"} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
